export const ORDER_STATUS_LIST_MUTATION = "ORDER_STATUS_LIST_MUTATION";
export const ORDER_KEYWORD_LIST_MUTATION = "ORDER_KEYWORD_LIST_MUTATION";
